import {configureStore} from '@reduxjs/toolkit';
import discoReducer from '../components/Discovery/discoveryCallSlice';

const store = () => configureStore({
    reducer: {
        discovery: discoReducer
    }
});

export default store;